export default __webpack_public_path__ + "static/media/manual-click.a58281b1.png";